"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUseFormState = require("react-use-form-state");
var _reactstrap = require("reactstrap");
var _Button = require("../Button/Button");
var _RecordForm = require("./RecordForm.styled");
var _RecordingSettings = _interopRequireWildcard(require("./RecordingSettings"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var RecordForm = function RecordForm(_ref) {
  var _onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    recording = _ref.recording;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var subHeader = 'Recordings are available in Past Recordings.';
  var recordingTitle = 'Recording name';
  var addOrSaveButtonText = recording ? 'Save' : 'Add';
  var formStateRecordingSettings = Object.create(null);
  /*
    If recording is passed as a prop, we want to use the
    existing env settings as the default settings
  */
  if (recording) {
    formStateRecordingSettings = (0, _RecordingSettings.extractRecordingSettings)(recording.env);
  }
  var _useFormState = (0, _reactUseFormState.useFormState)({
      title: recording ? recording.title : '',
      /**
       * initializing with the defaults or exiting settings
       */
      VIDEO_RESOLUTION: recording ? formStateRecordingSettings.VIDEO_RESOLUTION : _RecordingSettings["default"].videoResolution[1].id // 1920x1080
    }),
    _useFormState2 = (0, _slicedToArray2["default"])(_useFormState, 2),
    formState = _useFormState2[0],
    text = _useFormState2[1].text;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Form, {
    "data-test": "new-recording-form",
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      setIsSubmitting(true);
      var recordData = {
        title: formState.values.title.trim(),
        env: {
          SCREEN_WIDTH: formState.values.VIDEO_RESOLUTION.split('x')[0],
          SCREEN_HEIGHT: formState.values.VIDEO_RESOLUTION.split('x')[1]
        }
      };
      _onSubmit(recordData);
    }
  }, /*#__PURE__*/_react["default"].createElement(_RecordForm.StyledSubHeader, null, subHeader), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Label, {
    id: "recordingTitleLabel",
    htmlFor: "recordingTitle"
  }, recordingTitle), /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, (0, _extends2["default"])({
    "data-testid": "recordingTitleInput",
    id: "recordingTitle",
    "aria-labelledby": "recordingTitleLabel",
    placeholder: "1080p Recording"
  }, text({
    name: 'title',
    validate: function validate(t) {
      return t.trim().length >= 1;
    },
    validateOnBlur: false,
    touchOnChange: true
  }), {
    invalid: formState.touched.title && !formState.validity.title,
    required: true
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormFeedback, null, "Uh oh! A title is required.")), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Label, {
    htmlFor: "videoResolution"
  }, "Video resolution"), /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, {
    type: "select",
    onChange: function onChange(e) {
      formState.setField('VIDEO_RESOLUTION', e.target.value);
    },
    id: "videoResolution",
    value: formState.values.VIDEO_RESOLUTION
  }, _RecordingSettings["default"].videoResolution.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: item.id,
      value: item.id
    }, item.name);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "float-end"
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    "data-testid": "createButton",
    color: "primary",
    disabled: computeDisabledState(formState, recording, isSubmitting)
  }, isSubmitting ? 'Adding...' : addOrSaveButtonText), ' ', /*#__PURE__*/_react["default"].createElement(_RecordForm.StyledCancelButton, {
    "data-test": "cancelButton",
    onClick: function onClick(e) {
      e.preventDefault();
      onCancel();
    },
    color: "light",
    variant: "outlined"
  }, "Cancel"))));
};
function isFormChanged(formState) {
  return Object.values(formState.touched).some(function (value) {
    return value === true;
  });
}
function formIsValid(formState) {
  return formState.validity.title;
}
function computeDisabledState(formState, recording, isSubmitting) {
  if (recording) {
    var editState = formState.touched.title ? !formIsValid(formState) : !isFormChanged(formState);
    return editState || isSubmitting;
  }
  return !formIsValid(formState) || isSubmitting;
}
RecordForm.propTypes = {
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  recording: _propTypes["default"].object
};
var _default = exports["default"] = RecordForm;